// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__33jke","left":"InfoRow_left__3Ay9-"};